// Generated by `node i18n/tools/sync.mjs` from i18n/; do not edit.
export interface LocaleInfo {
  code: string;
  name: string;
  english: string;
  tiers: ("A" | "B")[];
  dir: "ltr" | "rtl";
  script: string;
  font: string | null;
  plurals: string[];
  fallback: string[];
  status: "source" | "machine" | "reviewed" | "pseudo";
  aliases?: string[];
}

export const SOURCE_LOCALE = "en";
export const LOCALES: LocaleInfo[] = [
  {
    "code": "en",
    "name": "English (US)",
    "english": "English",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [],
    "status": "source",
    "aliases": [
      "en-US"
    ]
  },
  {
    "code": "es",
    "name": "Español (Latinoamérica)",
    "english": "Spanish",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "es-419",
      "es-MX",
      "es-US",
      "es-AR",
      "es-CO",
      "es-CL",
      "es-PE"
    ]
  },
  {
    "code": "pt-BR",
    "name": "Português (Brasil)",
    "english": "Portuguese (Brazil)",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "many",
      "other"
    ],
    "fallback": [
      "pt",
      "en"
    ],
    "status": "machine",
    "aliases": [
      "pt"
    ]
  },
  {
    "code": "fr",
    "name": "Français (France)",
    "english": "French",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "fr-FR",
      "fr-BE",
      "fr-CH"
    ]
  },
  {
    "code": "de",
    "name": "Deutsch",
    "english": "German",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "de-DE",
      "de-AT",
      "de-CH"
    ]
  },
  {
    "code": "it",
    "name": "Italiano",
    "english": "Italian",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "nl",
    "name": "Nederlands",
    "english": "Dutch",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "nl-BE"
    ]
  },
  {
    "code": "pl",
    "name": "Polski",
    "english": "Polish",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "few",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "ru",
    "name": "Русский",
    "english": "Russian",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "cyrillic",
    "font": null,
    "plurals": [
      "one",
      "few",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "uk",
    "name": "Українська",
    "english": "Ukrainian",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "cyrillic",
    "font": null,
    "plurals": [
      "one",
      "few",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "tr",
    "name": "Türkçe",
    "english": "Turkish",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "ar",
    "name": "العربية",
    "english": "Arabic",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "rtl",
    "script": "arabic",
    "font": "Noto Sans Arabic",
    "plurals": [
      "zero",
      "one",
      "two",
      "few",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "he",
    "name": "עברית",
    "english": "Hebrew",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "rtl",
    "script": "hebrew",
    "font": "Noto Sans Hebrew",
    "plurals": [
      "one",
      "two",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "iw"
    ]
  },
  {
    "code": "hi",
    "name": "हिन्दी",
    "english": "Hindi",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "devanagari",
    "font": "Noto Sans Devanagari",
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "ja",
    "name": "日本語",
    "english": "Japanese",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "japanese",
    "font": "Noto Sans JP",
    "plurals": [
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "ko",
    "name": "한국어",
    "english": "Korean",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "korean",
    "font": "Noto Sans KR",
    "plurals": [
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "zh-CN",
    "name": "简体中文",
    "english": "Chinese (Simplified)",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "simplified-chinese",
    "font": "Noto Sans SC",
    "plurals": [
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "zh-Hans",
      "zh",
      "zh-SG",
      "zh-Hans-CN"
    ]
  },
  {
    "code": "vi",
    "name": "Tiếng Việt",
    "english": "Vietnamese",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "th",
    "name": "ไทย",
    "english": "Thai",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "thai",
    "font": "Noto Sans Thai",
    "plurals": [
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "id",
    "name": "Bahasa Indonesia",
    "english": "Indonesian",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "in"
    ]
  },
  {
    "code": "el",
    "name": "Ελληνικά",
    "english": "Greek",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "greek",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "en-GB",
    "name": "English (UK)",
    "english": "English (United Kingdom)",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "en-AU",
      "en-NZ",
      "en-IE",
      "en-IN",
      "en-ZA"
    ]
  },
  {
    "code": "es-ES",
    "name": "Español (España)",
    "english": "Spanish (Spain)",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "many",
      "other"
    ],
    "fallback": [
      "es",
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "pt-PT",
    "name": "Português (Portugal)",
    "english": "Portuguese (Portugal)",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "many",
      "other"
    ],
    "fallback": [
      "pt-BR",
      "en"
    ],
    "status": "machine",
    "aliases": [
      "pt-AO",
      "pt-MZ"
    ]
  },
  {
    "code": "fr-CA",
    "name": "Français (Canada)",
    "english": "French (Canada)",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "many",
      "other"
    ],
    "fallback": [
      "fr",
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "zh-Hant",
    "name": "繁體中文",
    "english": "Chinese (Traditional)",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "traditional-chinese",
    "font": "Noto Sans TC",
    "plurals": [
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "zh-TW",
      "zh-HK",
      "zh-MO",
      "zh-Hant-TW",
      "zh-Hant-HK"
    ]
  },
  {
    "code": "sv",
    "name": "Svenska",
    "english": "Swedish",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "da",
    "name": "Dansk",
    "english": "Danish",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "nb",
    "name": "Norsk bokmål",
    "english": "Norwegian (Bokmål)",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "no",
      "nn"
    ]
  },
  {
    "code": "fi",
    "name": "Suomi",
    "english": "Finnish",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "bn",
    "name": "বাংলা",
    "english": "Bengali",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "bengali",
    "font": "Noto Sans Bengali",
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "ur",
    "name": "اردو",
    "english": "Urdu",
    "tiers": [
      "B"
    ],
    "dir": "rtl",
    "script": "urdu",
    "font": "Noto Nastaliq Urdu",
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "hy",
    "name": "Հայերեն",
    "english": "Armenian",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "armenian",
    "font": "Noto Sans Armenian",
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "bg",
    "name": "Български",
    "english": "Bulgarian",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "cyrillic",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "hr",
    "name": "Hrvatski",
    "english": "Croatian",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "few",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "cs",
    "name": "Čeština",
    "english": "Czech",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "few",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "et",
    "name": "Eesti",
    "english": "Estonian",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "fa",
    "name": "فارسی",
    "english": "Persian",
    "tiers": [
      "B"
    ],
    "dir": "rtl",
    "script": "arabic",
    "font": "Noto Sans Arabic",
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "fa-IR"
    ]
  },
  {
    "code": "hu",
    "name": "Magyar",
    "english": "Hungarian",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "lv",
    "name": "Latviešu",
    "english": "Latvian",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "zero",
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "lt",
    "name": "Lietuvių",
    "english": "Lithuanian",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "few",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "ms",
    "name": "Bahasa Melayu",
    "english": "Malay",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "ms-MY"
    ]
  },
  {
    "code": "ro",
    "name": "Română",
    "english": "Romanian",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "few",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "sr-Latn",
    "name": "Srpski (latinica)",
    "english": "Serbian (Latin)",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "few",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "sr",
      "sr-RS",
      "sr-Latn-RS",
      "sh"
    ]
  },
  {
    "code": "sk",
    "name": "Slovenčina",
    "english": "Slovak",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "few",
      "many",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "sl",
    "name": "Slovenščina",
    "english": "Slovenian",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "two",
      "few",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "sw",
    "name": "Kiswahili",
    "english": "Swahili",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "mr",
    "name": "मराठी",
    "english": "Marathi",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "devanagari",
    "font": "Noto Sans Devanagari",
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "te",
    "name": "తెలుగు",
    "english": "Telugu",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "telugu",
    "font": "Noto Sans Telugu",
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine"
  },
  {
    "code": "fil",
    "name": "Filipino",
    "english": "Filipino",
    "tiers": [
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "machine",
    "aliases": [
      "tl"
    ]
  }
];
export const PSEUDO_LOCALES: LocaleInfo[] = [
  {
    "code": "en-XA",
    "name": "[Ēñĝļîšĥ]",
    "english": "Pseudo (accented)",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "ltr",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "pseudo"
  },
  {
    "code": "ar-XB",
    "name": "‮English‬",
    "english": "Pseudo (mirrored)",
    "tiers": [
      "A",
      "B"
    ],
    "dir": "rtl",
    "script": "latin",
    "font": null,
    "plurals": [
      "one",
      "other"
    ],
    "fallback": [
      "en"
    ],
    "status": "pseudo"
  }
];
